<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <TextBasicData class="d-flex justify-content-center" />
        <div class="form-group">
          <label for="name"> Nome Completo </label>
          <input
            type="text"
            id="name"
            name="name"
            v-model="Fields.name"
            aria-describedby="Nome para Cadastro"
            placeholder="Digite seu nome completo"
            class="form-control"
            @input="ErrorMessages.name = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.name !== null"
          >
            {{ ErrorMessages.name }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="chooseTypePerson">Fazer cadastro como:</label>
          <b-form-radio-group
            id="chooseTypePerson"
            name="chooseTypePerson"
            @change="ErrorMessages.typePerson = null"
          >
            <b-form-radio v-model="typePerson" value="physicalPerson">
              <a class="pointer">Pessoa Física</a>
            </b-form-radio>

            <b-form-radio v-model="typePerson" value="juridicPerson">
              <a class="pointer">Pessoa Jurídica</a>
            </b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div class="col-lg-4 col-md-6" v-if="typePerson === 'physicalPerson'">
        <div class="form-group">
          <label for="rg"> RG </label>
          <input
            type="text"
            v-model="Fields.rg"
            id="rg"
            name="rg"
            v-mask="'##.###.###-X'"
            aria-describedby="RG para Cadastro"
            placeholder="Digite seu RG"
            class="form-control"
            @input="ErrorMessages.rg = null"
          />
          <p class="error-message text-danger" v-if="ErrorMessages.rg !== null">
            {{ ErrorMessages.rg }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6" v-if="typePerson === 'physicalPerson'">
        <div class="form-group">
          <label for="cpf"> CPF </label>
          <input
            type="text"
            v-model="Fields.cpf"
            id="cpf"
            name="cpf"
            v-mask="'###.###.###-##'"
            aria-describedby="CPF para Cadastro"
            placeholder="Digite seu CPF"
            class="form-control"
            @input="ErrorMessages.cpf = null"
          />
        </div>
        <p class="error-message text-danger" v-if="ErrorMessages.cpf !== null">
          {{ ErrorMessages.cpf }}
        </p>
      </div>
      <div class="col-lg-4 col-md-6" v-if="typePerson === 'juridicPerson'">
        <div class="form-group">
          <label for="cnpj"> CNPJ </label>
          <input
            type="text"
            v-model="Fields.cnpj"
            id="cnpj"
            name="cnpj"
            v-mask="'##.###.###/####-##'"
            aria-describedby="CNPJ para Cadastro"
            placeholder="Digite seu CNPJ"
            class="form-control"
            @input="ErrorMessages.cnpj = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cnpj !== null"
          >
            {{ ErrorMessages.cnpj }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cellphone"> Celular </label>
          <input
            type="text"
            v-model="Fields.cellphone"
            id="cellphone"
            name="cellphone"
            v-mask="['(##) #####-####', '(##) ####-####']"
            aria-describedby="Celular para Cadastro"
            placeholder="Digite seu celular"
            class="form-control"
            @input="ErrorMessages.cellphone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cellphone !== null"
          >
            {{ ErrorMessages.cellphone }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="telephone"> Telefone </label>
          <input
            type="text"
            id="telephone"
            name="telephone"
            v-model="Fields.telephone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Telefone para Cadastro"
            placeholder="Digite seu telefone"
            class="form-control"
            @input="ErrorMessages.telephone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone !== null"
          >
            {{ ErrorMessages.telephone }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="telephone2"> Telefone 2 </label>
          <input
            type="text"
            id="telephone2"
            name="telephone2"
            v-model="Fields.telephone2"
            v-mask="['(##) ####-####', '(##) #####-####']"
            aria-describedby="Telefone para Cadastro"
            placeholder="Digite seu telefone 2"
            class="form-control"
            @input="ErrorMessages.telephone2 = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone2 !== null"
          >
            {{ ErrorMessages.telephone2 }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-12">
      <hr />
    </div>
    <div class="col-12">
      <TextAddress class="d-flex justify-content-center" />
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cep"> CEP </label>
          <input
            type="text"
            v-model="Fields.cep"
            id="cep"
            name="cep"
            v-mask="'#####-###'"
            aria-describedby="CEP para Cadastro"
            placeholder="Digite seu CEP"
            class="form-control"
            @input="ErrorMessages.cep = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cep !== null"
          >
            {{ ErrorMessages.cep }}
          </p>
        </div>
      </div>
      <div class="col-lg-8 col-md-6">
        <div class="form-group">
          <label for="address"> Endereço </label>
          <input
            type="text"
            v-model="Fields.address"
            id="address"
            name="address"
            aria-describedby="Endereço para Cadastro"
            placeholder="Digite seu Endereço"
            class="form-control"
            @input="ErrorMessages.address = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidAddress)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="number"> Número </label>
          <input
            type="text"
            v-model="Fields.number"
            id="number"
            name="number"
            aria-describedby="Número para Cadastro"
            placeholder="Digite seu Número"
            class="form-control"
            @input="ErrorMessages.number = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number !== null"
          >
            {{ ErrorMessages.number }}
          </p>
        </div>
      </div>
      <div class="col-lg-8 col-md-6">
        <div class="form-group">
          <label for="complement"> Complemento (opcional) </label>
          <input
            type="text"
            v-model="Fields.complement"
            id="complement"
            name="complement"
            aria-describedby="Complemento para Cadastro"
            placeholder="Digite seu Complemento"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="form-group">
          <label for="neighborhood"> Bairro </label>
          <input
            type="text"
            v-model="Fields.neighborhood"
            id="neighborhood"
            name="neighborhood"
            aria-describedby="Bairro para cadastro"
            placeholder="Digite o bairro"
            class="form-control"
            @input="ErrorMessages.neighborhood = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidNeighborhood)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="city_id"> Cidade </label>
          <v-select
            disabled
            id="city_id"
            name="city_id"
            class="no-search"
            label="nome"
            placeholder="Selecione a cidade"
            v-model="Fields.city_id"
            :key="Fields.city_id"
            :options="getCities"
            :reduce="(city) => city.id"
            @input="ErrorMessages.city_id = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city_id !== null"
          >
            {{ ErrorMessages.city_id }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <label for="cadastroEstado"> Estado </label>
          <v-select
            disabled
            id="state_id"
            name="state_id"
            placeholder="Selecione o estado da empresa"
            label="nome"
            autocomplete="nope"
            class="no-search"
            v-model="Fields.state_id"
            :key="Fields.state_id"
            @input="ErrorMessages.state_id = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.state_id !== null"
          >
            {{ ErrorMessages.state_id }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="fantasy"> Nome Fantasia </label>
          <span class="ml-2">
            <i
              class="fas fa-question-circle question-tool-tips"
              id="fantasyName"
            ></i>
            <BTooltip target="fantasyName">
              <div>Nome que será exibido no anúncio do seu perfil</div>
            </BTooltip>
          </span>
          <input
            type="text"
            id="fantasy"
            aria-describedby="Nome fantasia para Cadastro"
            placeholder="Digite seu nome fantasia"
            class="form-control"
            v-model="Fields.fantasy"
            @input="ErrorMessages.fantasy = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.fantasy !== null"
          >
            {{ ErrorMessages.fantasy }}
          </p>
        </div>
        <hr class="my-4" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TextAccess class="d-flex justify-content-center" />
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="email"> E-mail </label>
          <input
            type="text"
            v-model="Fields.email"
            id="email"
            name="email"
            aria-describedby="Email para Cadastro"
            placeholder="Digite um E-mail para acessar a plataforma"
            class="form-control"
            @input="ErrorMessages.email = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email !== null"
          >
            {{ ErrorMessages.email }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <InputPassword
            :value.sync="Fields.password"
            :errorMessage.sync="ErrorMessages.password"
          />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <InputPassword
          :label="'Confirme sua senha'"
          :value.sync="confirmPassword"
          :errorMessage.sync="ErrorMessages.confirmPassword"
          :placeholder="'Digite novamente a sua senha'"
        />
      </div>
      <div class="col-12 mt-3">
        <div class="form-group d-flex justify-center">
          <b-form-checkbox
            id="termos"
            name="termsAndConditions"
            v-model="acceptedTermsAndConditions"
            @change="ErrorMessages.termsAndConditions = null"
          >
          </b-form-checkbox>

          <div class="font-weight-normal">
            Li e aceito os
            <span class="c-orange c-pointer" v-b-modal="'termos'"
              >termos e condições</span
            >
            e as
            <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
              >politicas de privacidade.</span
            >
          </div>

          <p
            v-if="ErrorMessages.termsAndConditions !== null"
            class="error-message text-danger"
          >
            {{ ErrorMessages.termsAndConditions }}
          </p>
        </div>
        <div class="form-group">
          <button
            type="submit"
            class="btn bg-orange c-white text-uppercase"
            @click="register()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';
import login from '../../mixins/login';
import TextAccess from '../../components/Register/TextAccess.vue';
import TextBasicData from '../../components/Register/TextBasicData.vue';
import TextAddress from '../../components/Register/TextAddress.vue';
import InputPassword from '../../components/Inputs/InputPassword.vue';

export default {
  name: 'ProfessionalRegister',
  mixins: [makeToast, login],
  props: {
    userId: {
      type: Number,
    },
  },
  components: {
    TextAccess,
    TextBasicData,
    TextAddress,
    InputPassword,
  },
  data() {
    return {
      Fields: {
        email: null,
        password: null,
        cpf: null,
        rg: null,
        cnpj: null,
        name: null,
        cep: null,
        state_id: null,
        neighborhood: null,
        city_id: null,
        typePerson: 2,
        fantasy: null,
        telephone: null,
        telephone2: null,
        address: null,
        cellphone: null,
        complement: null,
      },
      ErrorMessages: {
        email: null,
        password: null,
        confirmPassword: null,
        cpf: null,
        rg: null,
        cnpj: null,
        name: null,
        cellphone: null,
        telephone: null,
        telephone2: null,
        address: null,
        number: null,
        cep: null,
        neighborhood: null,
        city_id: null,
        state_id: null,
        fantasy: null,
        termsAndConditions: null,
        privacyPolicy: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      typePerson: null,
      confirmPassword: null,
      acceptedTermsAndConditions: false,
      acceptedPrivacyPolicy: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('general', ['getCities']),
    ...mapGetters(['getTipoNotification', 'getNotification', 'getBaseUri']),
    ...mapState([
      'tipoUsuarios',
      'estados',
      'cidades',
      'planos',
      'segmentos',
      'dadosUsuario',
    ]),
  },
  watch: {
    'Fields.cep': function () {
      this.consultCep();
    },
  },
  methods: {
    register() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');

        if (this.userId) {
          Object.assign(this.Fields, { userId: this.userId });
        }

        this.$store
          .dispatch('professional/register', this.Fields)
          .then((response) => {
                        this.makeToast('Sucesso!', response.data.message);
            setTimeout(() => {
              this.login(this.Fields.email, this.Fields.password);
            }, 1000);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
            localStorage.setItem('emailField', this.Fields.email);
          })
          .finally(() => this.$store.dispatch('endLoader'));
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.$validate.name(this.Fields.name)) {
        this.ErrorMessages.name = 'Nome inválido';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.fantasy)) {
        this.ErrorMessages.fantasy = 'Nome Fantasia inválido';
        isValid = false;
      }

      if (this.typePerson === 'physicalPerson') {
        if (
          this.Fields.rg !== null &&
          this.Fields.rg.length > 0 &&
          !this.$validate.rg(this.Fields.rg)
        ) {
          this.ErrorMessages.rg = 'RG inválido';
          isValid = false;
        }

        if (!this.$validate.cpf(this.Fields.cpf)) {
          this.ErrorMessages.cpf = 'CPF inválido';
          isValid = false;
        }
      }

      if (this.typePerson === 'juridicPerson') {
        if (!this.$validate.cnpj(this.Fields.cnpj)) {
          this.ErrorMessages.cnpj = 'CNPJ inválido';
          isValid = false;
        }
      }

      if (!this.$validate.telephone(this.Fields.cellphone)) {
        this.ErrorMessages.cellphone = 'Celular inválido';
        isValid = false;
      }

      // if (!this.$validate.telephone(this.Fields.telephone)) {
      //   this.ErrorMessages.telephone = 'Telefone inválido';
      //   isValid = false;
      // }

      // if (
      //   this.Fields.telephone2 !== null &&
      //   this.Fields.telephone2.length > 0 &&
      //   this.$validate.telephone(this.Fields.telephone2)
      // ) {
      //   this.ErrorMessages.telephone2 = 'Telefone 2 inválido';
      //   isValid = false;
      // }

      if (!this.$validate.address(this.Fields.address)) {
        this.ErrorMessages.address =
          'Endereço inválido, digite um com no mínimo 5 e no máximo 70 caracteres';
        isValid = false;
      }

      if (!this.$validate.cep(this.Fields.cep)) {
        this.ErrorMessages.cep = 'CEP inválido';
        isValid = false;
      }

      if (!this.$validate.neighborhood(this.Fields.neighborhood)) {
        this.ErrorMessages.neighborhood =
          'Bairro inválido, digite com no máximo 40 caracteres';
        isValid = false;
      }

      if (!this.$validate.addressNumber(this.Fields.number)) {
        this.ErrorMessages.number = 'Número inválido';
        isValid = false;
      }

      if (this.Fields.city_id === null) {
        this.ErrorMessages.city_id = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.Fields.state_id === null) {
        this.ErrorMessages.state_id = 'Você não selecionou nenhum estado';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email)) {
        this.ErrorMessages.email = 'Email inválido';
        isValid = false;
      }

      if (!this.$validate.password(this.Fields.password)) {
        this.ErrorMessages.password =
          'A senha precisa ter no mínimo 5 caracteres';
        isValid = false;
      }

      if (this.confirmPassword !== this.Fields.password) {
        this.ErrorMessages.confirmPassword = 'As senhas devem ser iguais';
        isValid = false;
      }

      if (!this.acceptedTermsAndConditions) {
        this.ErrorMessages.termsAndConditions =
          'Você precisa aceitar os termos e condições';
        isValid = false;
      }

      return isValid;
    },
    consultCep() {
      if (!this.loading && this.Fields.cep.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.Fields.cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }

      if (this.Fields.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.Fields.address = null;
        this.Fields.neighborhood = null;
        this.Fields.city_id = null;
        this.Fields.state_id = null;
      }
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;

      this.cepConsult.isValidAddress = !!result.logradouro;

      this.cepConsult.isValidNeighborhood = !!result.bairro;

      this.Fields.address = result.logradouro || null;
      this.Fields.neighborhood = result.bairro || null;
      this.Fields.city_id = result.cidade_id || null;
      this.Fields.state_id = result.uf || null;

      this.ErrorMessages.address = null;
      this.ErrorMessages.neighborhood = null;
      this.ErrorMessages.city_id = null;
      this.ErrorMessages.state_id = null;
    },
  },
};
</script>

<style scoped>
.no-search .vs_search {
  background: transparent;
}

div.form-group label {
  font-weight: 700;
}

div.col-12 label {
  font-weight: 700;
}
</style>
